import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { signin } from '../helpers/auth';



export default class Login extends Component{
    constructor(props){
        super(props);
        this.state = {
            error: null,
            email:'',
            password:''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    async handleSubmit(event){
        event.preventDefault()
        this.setState({ error: "" });
        try{
            await signin(this.state.email,this.state.password);
        } catch(error) {
            this.setState({ error: error.message });
        }
    }

    render(){
        return(
            <div class="mainPageContainer">
            <div class="formContainer">
                <form autoComplete="off" onSubmit={this.handleSubmit}>
                <h1>Login to <Link to="/" style={{ textDecoration: 'none', color: 'white', paddingLeft: '10px' }}> AREA 52 </Link></h1>
                <p> Fill in the form below to login to your account </p>
                <div class="formInputs">
                    <input placeholder="Email" name="email" type="email" onChange={this.handleChange} value={this.state.email}/>
                    <input placeholder="password" name="password" type="password" onChange={this.handleChange} value={this.state.password}/>
                
                    {this.state.error ? (
                        <p class="formError">{this.state.error}</p>
                    ) : null }
                    <span  onClick={this.handleSubmit} type="submit" class="formButtons">Login</span>
                </div>
                <p> Don't have an AREA 52 account? <Link to="/signup">SignUP</Link></p>
                </form>
                </div>
            </div>
        )
    }

}